import { useState } from 'react'
import { router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '@/components/ui/collapsible'
import { ChevronDown, Loader2 } from 'lucide-react'
import type { DigitalWorkerDetail } from '@/frontend/pages/Dashboard/DigitalWorkers/types'
import type { WorkerFormData } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

interface Props {
  form: WorkerFormData
  worker: DigitalWorkerDetail
  canManage: boolean
}

export default function AdvancedSettings({ form, worker, canManage }: Props) {
  const [syncingVault, setSyncingVault] = useState(false)
  const [open, setOpen] = useState(false)

  return (
    // DS novo: caixa plana (borda + radius-12, sem sombra); o cabeçalho do
    // acordeão é o próprio gatilho, largura total.
    <Collapsible open={open} onOpenChange={setOpen} className="rounded-xl border border-border bg-card">
      <CollapsibleTrigger asChild>
        <button type="button" className="flex w-full cursor-pointer select-none items-center gap-2 p-5 text-left">
          <ChevronDown className={`h-4 w-4 transition-transform ${open ? '' : '-rotate-90'}`} />
          <span className="text-[14px] font-semibold text-foreground">Avançado</span>
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="space-y-4 px-5 pb-5">
          <div className="grid gap-2">
            <Label htmlFor="advanced-instance-name">Nome da instância</Label>
            <Input id="advanced-instance-name" value={form.data.instance_name} onChange={(e) => form.setData('instance_name', e.target.value)} disabled={!canManage} />
            {form.errors.instance_name && <p className="text-sm text-destructive">{form.errors.instance_name}</p>}
          </div>
          <div className="grid gap-2">
            <Label htmlFor="advanced-api-endpoint-url">URL do endpoint da API</Label>
            <Input id="advanced-api-endpoint-url" value={form.data.api_endpoint_url} onChange={(e) => form.setData('api_endpoint_url', e.target.value)} disabled={!canManage} placeholder="https://…" />
            {form.errors.api_endpoint_url && <p className="text-sm text-destructive">{form.errors.api_endpoint_url}</p>}
          </div>
          <div className="grid gap-2">
            <Label htmlFor="advanced-webhook-token">Token do webhook</Label>
            <Input
              id="advanced-webhook-token"
              type="password"
              value={form.data.instance_hook_token}
              onChange={(e) => form.setData('instance_hook_token', e.target.value)}
              disabled={!canManage}
              placeholder={worker.instance_hook_token ? worker.instance_hook_token : 'Token de autenticação do webhook'}
            />
            {form.errors.instance_hook_token && <p className="text-sm text-destructive">{form.errors.instance_hook_token}</p>}
          </div>
          {worker.vault_configured && canManage && (
            <div className="flex items-center justify-end">
              <Button
                variant="outline"
                size="sm"
                disabled={syncingVault}
                onClick={() => {
                  setSyncingVault(true)
                  router.post(`/dashboard/digital_workers/${worker.id}/sync_vault`, {}, {
                    preserveScroll: true,
                    onFinish: () => setSyncingVault(false),
                  })
                }}
              >
                {syncingVault && <Loader2 className="h-4 w-4 animate-spin" />}
                Sincronizar vault
              </Button>
            </div>
          )}
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
